module.exports = __webpack_public_path__ + "img/bg.98df65f6.webp";